import { render, staticRenderFns } from "./AddVip.vue?vue&type=template&id=570384bc&scoped=true&"
import script from "./AddVip.vue?vue&type=script&lang=js&"
export * from "./AddVip.vue?vue&type=script&lang=js&"
import style0 from "./AddVip.vue?vue&type=style&index=0&lang=less&"
import style1 from "./AddVip.vue?vue&type=style&index=1&id=570384bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570384bc",
  null
  
)

export default component.exports